<template>
    <v-card  class="vwidget-card " :class="`elevation-${elevation}`">
      <!-- <v-flex class="vwidget-top-icon" primary>
        <v-icon color="white" x-large="">home</v-icon>
      </v-flex> -->
      <v-layout column>
        <v-toolbar class="white" flat  dense  v-if="enableHeader">
          <v-toolbar-title><h4 v-html="showTitle"></h4></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex d-flex justify-end="">
              <div class="dd-page-button-top-right"  >
                  <slot name="button-top-right" d-flex></slot>
              </div>    
          </v-flex>    
          <slot name="widget-header-action"></slot>
        </v-toolbar>
        <v-divider v-if="enableHeader"></v-divider>
        <v-card-text>
          <slot name="widget-content"></slot>       
        </v-card-text>       
      </v-layout>
    </v-card>  
</template>

<script>
export default {
  name: 'v-widget',
  props: {
    title: {
      type: String,
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    elevation: {
      type: Number,
      default: 12
    }
    // contentBg: {
    //   type: String,
    //   default: 'white'
    // }
  },

  data () {
    return {

    };
  },
  computed: {
      showTitle(){
          return this.title
      }
  },  
};
</script>
<style scoped>
  .dd-page-button-top-right {
        position:absolute;
        margin-top: -10px;    
        z-index: 105;
    }

  /* .vwidget-card{
    margin-top: 120px;
  } */

  .vwidget-top-icon{
    height: 80px;
    width: 80px;
    right:0;
    margin-top: -80px;
    position: absolute;
    z-index: 200;    
    flex:1;
    display: flex;
    justify-content: center;
    color: #fff !important;
  }
</style>
